import React, { useState } from "react";
import { Flex } from "rebass/styled-components";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import theme from "../../../../../theme/themeThree";
import { StudioSession } from "../../../../State/studioSession";
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";

export const EnabledCards = ({
  enabledCardsVisible,
  setEnabledCardsVisible,
}: any) => {
  const { userActivated } = useRecoilValue(StudioSession);
  const [isChecked, setIsChecked] = useState(false);

  return (
    <StyledFlex
      title="Enabled Cards"
      alignItems={"center"}
      mr={[2, 2, 4, 4]}
      px={1}
      py={1}
      style={{
        cursor: "pointer",
      }}
      onClick={(e: any) => {
        setEnabledCardsVisible(!enabledCardsVisible);
        setIsChecked(!enabledCardsVisible);
      }}
    >
      <NumberBox py={1} px={[3, 3, 3, 2]} alignItems="center">
        {userActivated.length}{" "}
      </NumberBox>
      {isChecked ? <StyledRIcon /> : <StyledLIcon />}
    </StyledFlex>
  );
};

const StyledLIcon = styled(BiArrowToLeft)<any>`
  display: flex;
  margin-left: 3px;
  height: 20px;
  width: 20px;
  padding: 3px;
  color: ${(props: any) => props.theme.colors.ice};
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    display: none;
  }
`;

const StyledRIcon = styled(BiArrowToRight)<any>`
  display: flex;
  margin-left: 3px;
  height: 20px;
  width: 20px;
  padding: 3px;
  color: ${(props: any) => props.theme.colors.ice};
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    display: none;
  }
`;

const NumberBox = styled(Flex)`
  background: linear-gradient(95deg, #a680da 0%, #7a9dd2 100%);
  border-radius: 8px;
  min-width: 42px;
  min-height: 36px;
  justify-content: center;
  font-weight: 600;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    min-width: 26px;
    min-height: 26px;
  }
`;

const StyledFlex = styled(Flex)`
  background-color: ${theme.colors.ned};
  border-radius: 10px;
  border: 1px solid;
  border-color: ${theme.colors.ned};
  &:hover {
    background: ${theme.colors.midnightAlpha50};
  }
  &:hover ${NumberBox} {
    background: linear-gradient(75deg, #a680da 0%, #7a9dd2 100%);
  }
  &:hover ${StyledLIcon} {
    color: #7a9dd2;
  }
  &:hover ${StyledRIcon} {
    color: #7a9dd2;
  }
  // @media (max-width: ${({ theme }) => theme.breaks.medium}) {
  //   display: none;
  // }
`;
